<template>
  <div class="mt-8 grid grid-cols-1 gap-6">
    <!-- 5 derniers projets -->
    <div class="bg-white shadow-sm rounded-2xl border border-gray-100 overflow-x-auto">
      <h3 class="px-6 py-4 text-lg font-semibold text-gray-800">5 derniers projets</h3>
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nom</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Statut</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Avancement</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Début</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fin</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="projet in derniersProjets" :key="projet._id">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ projet.nomProjet }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">
              <span
                class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                :class="statutProjetClass(projet.statut)"
              >
                {{ projet.statut }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ projet.realisation }}%</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(projet.timeline.debut) }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(projet.timeline.fin) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 5 dernières factures -->
    <div class="bg-white shadow-sm rounded-2xl border border-gray-100 overflow-x-auto">
      <h3 class="px-6 py-4 text-lg font-semibold text-gray-800">5 dernières factures</h3>
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Facture</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Montant</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Statut</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Projet</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="facture in dernieresFactures" :key="facture.id">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ facture.objet }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ facture.montant }} €</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">
              <span
                class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                :class="statutFactureClass(facture.statut)"
              >
                {{ facture.statut }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ facture.date }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ facture.projet }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

const derniersProjets = ref([])
const dernieresFactures = ref([])

// --- Projets ---
const fetchProjets = async () => {
  try {
    const token = localStorage.getItem('token')
    const { data } = await axios.get('https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/dashboard', {
      headers: { Authorization: `Bearer ${token}` }
    })
    derniersProjets.value = data.projets.slice(0, 5)
  } catch (err) {
    console.error('Erreur récupération projets :', err)
  }
}

// --- Factures ---
const fetchFactures = async () => {
  try {
    const token = localStorage.getItem('token')
    const { data } = await axios.get('https://datafuseweb-95a5588f8542.herokuapp.com/api/factures', {
      headers: { Authorization: `Bearer ${token}` }
    })

    dernieresFactures.value = data.factures
      .slice(0, 5)
      .map(f => ({
        id: f._id,
        numero: f.numeroFacture || '#FAC000',
        projet: f.devisNumero || 'N/A',
        objet: f.objet,
        date: new Date(f.date).toLocaleDateString('fr-FR'),
        statut: f.statut.toLowerCase(),
        montant: f.montant
      }))
  } catch (err) {
    console.error('Erreur récupération factures :', err)
  }
}

// --- Helpers ---
const formatDate = dateStr => dateStr ? new Date(dateStr).toLocaleDateString('fr-FR') : '-'

const statutProjetClass = statut => {
  switch(statut) {
    case 'En cours': return 'bg-blue-100 text-blue-800'
    case 'Terminé': return 'bg-green-100 text-green-800'
    case 'En attente': return 'bg-yellow-100 text-yellow-800'
    case 'En retard': return 'bg-red-100 text-red-800'
    default: return 'bg-gray-100 text-gray-800'
  }
}

const statutFactureClass = statut => {
  switch(statut.toLowerCase()) {
    case 'payée': return 'bg-green-100 text-green-800'
    case 'en attente': return 'bg-yellow-100 text-yellow-800'
    case 'envoyé': return 'bg-gray-100 text-gray-800'
    default: return 'bg-gray-100 text-gray-800'
  }
}

// --- On mounted ---
onMounted(() => {
  fetchProjets()
  fetchFactures()
})
</script>
